import request from '@/utils/request'


// 查询地区距离信息列表
export function listAreaDistance(query) {
  return request({
    url: '/biz/admin/area/distance/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

export function groupAreaDistance(query) {
  return request({
    url: '/biz/admin/area/distance/group/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询地区距离信息分页
export function pageAreaDistance(query) {
  return request({
    url: '/biz/admin/area/distance/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询地区距离信息详细
export function getAreaDistance(data) {
  return request({
    url: '/biz/admin/area/distance/detail',
    method: 'get',
    params: data
  })
}

// 新增地区距离信息
export function addAreaDistance(data) {
  return request({
    url: '/biz/admin/area/distance/add',
    method: 'post',
    data: data
  })
}

// 修改地区距离信息
export function updateAreaDistance(data) {
  return request({
    url: '/biz/admin/area/distance/edit',
    method: 'post',
    data: data
  })
}

// 删除地区距离信息
export function delAreaDistance(data) {
  return request({
    url: '/biz/admin/area/distance/delete',
    method: 'post',
    data: data
  })
}

export function importAreaDistance(data) {
  return request({
    url: '/biz/admin/area/distance/import',
    method: 'post',
    data: data
  })
}

export function areaDistanceTemplate(data) {
  return request({
    url: '/biz/admin/area/distance/template',
    method: 'post',
    data: data
  })
}
